"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TwoWayTransition = _interopRequireDefault(require("./TwoWayTransition"));

var _Functions = require("../core/Functions");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transition: ", ";\n  height: ", ";\n  opacity: ", ";\n  pointer-events: ", ";\n  transform: ", ";\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AccordionTransitionWrapper = (0, _styledComponents.default)(function (_ref) {
  var open = _ref.open,
      __measuredHeight = _ref.measuredHeight,
      transitioning = _ref.transitioning,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["open", "measuredHeight", "transitioning"]);
  return _react.default.createElement(_TwoWayTransition.default.PlainWrapper, (0, _extends2.default)({
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "AccordionTransition__AccordionTransitionWrapper",
  componentId: "sc-110ctgr-0"
})(_templateObject(), function (_ref2) {
  var duration = _ref2.duration,
      measuredHeight = _ref2.measuredHeight,
      transitionActive = _ref2.transitionActive;
  return measuredHeight != null && transitionActive ? "height " + duration + "ms cubic-bezier(0.25, 0.1, 0.25, 1),\n    opacity " + duration + "ms cubic-bezier(0.42, 0, 0.58, 1),\n    transform " + duration + "ms cubic-bezier(0.42, 0, 0.58, 1)" : 'none';
}, function (_ref3) {
  var open = _ref3.open,
      measuredHeight = _ref3.measuredHeight,
      transitioning = _ref3.transitioning;
  return transitioning && (open ? measuredHeight + "px" : 0);
}, function (_ref4) {
  var open = _ref4.open,
      transitioning = _ref4.transitioning;
  return transitioning && (open ? 1 : 0);
}, function (_ref5) {
  var transitioning = _ref5.transitioning;
  return transitioning && 'none';
}, function (_ref6) {
  var open = _ref6.open,
      transitioning = _ref6.transitioning;
  return transitioning && "translateY(" + (open ? '0' : '-10px') + ")";
});

var AccordionTransition =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AccordionTransition, _PureComponent);

  function AccordionTransition(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AccordionTransition);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccordionTransition).call(this, props));

    _this.handleTransitionStart = function () {
      _this.setState({
        transitioning: true
      });
    };

    _this.handleTransitionComplete = function () {
      _this.setState({
        transitioning: false
      });
    };

    _this.state = {
      measuredHeight: 0,
      // 0 = not needed, null = needed
      transitioning: false
    };
    return _this;
  }

  (0, _createClass2.default)(AccordionTransition, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.open !== nextProps.open && !this.state.transitioning) {
        this.setState({
          measuredHeight: null
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.measuredHeight == null) {
        this.measureHeight();
      }
    }
  }, {
    key: "measureHeight",
    value: function measureHeight() {
      var el = (0, _reactDom.findDOMNode)(this);
      if (!el) return;
      this.setState({
        measuredHeight: el.scrollHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          Content = _this$props.Content,
          renderContent = _this$props.renderContent,
          duration = _this$props.duration,
          onOpenStart = _this$props.onOpenStart,
          onCloseStart = _this$props.onCloseStart,
          onOpenComplete = _this$props.onOpenComplete,
          onCloseComplete = _this$props.onCloseComplete,
          open = _this$props.open,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "Content", "renderContent", "duration", "onOpenStart", "onCloseStart", "onOpenComplete", "onCloseComplete", "open"]);
      var renderedContent = null;

      if (open) {
        if (Content) {
          renderedContent = _react.default.createElement(Content, null);
        } else if (renderContent) {
          renderedContent = renderContent();
        } else {
          renderedContent = children;
        }
      }

      return _react.default.createElement(_TwoWayTransition.default, (0, _extends2.default)({}, rest, {
        duration: duration,
        measuredHeight: this.state.measuredHeight,
        onOpenStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onOpenStart),
        onCloseStart: (0, _Functions.memoizedSequence)(this.handleTransitionStart, onCloseStart),
        onOpenComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onOpenComplete),
        onCloseComplete: (0, _Functions.memoizedSequence)(this.handleTransitionComplete, onCloseComplete)
      }), renderedContent);
    }
  }]);
  return AccordionTransition;
}(_react.PureComponent);

AccordionTransition.propTypes = {
  children: _propTypes.default.node,
  Content: _propTypes.default.elementType,
  renderContent: _propTypes.default.func,
  duration: _propTypes.default.number.isRequired,
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  Wrapper: _propTypes.default.elementType.isRequired
};
AccordionTransition.defaultProps = {
  duration: 200,
  Wrapper: AccordionTransitionWrapper
};
AccordionTransition.displayName = 'AccordionTransition';
var _default = AccordionTransition;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/transitions/AccordionTransition.js
// module id = 120
// module chunks = 5 6